import React, { createContext, useState, useEffect, useContext } from 'react';
const ThemeContext = createContext();
export const Context = () => useContext(ThemeContext);
export const ContextProvider = ({ children }) => {

    const [language, setLanguage] = useState(() => {
        const storedLanguage = sessionStorage.getItem('language');
        return storedLanguage ? storedLanguage : 'English';
    });

    useEffect(() => { sessionStorage.setItem('language', language) }, [language]);

    const toggleLanguage = (lng) => setLanguage(lng)

    return (
        <ThemeContext.Provider value={{ toggleLanguage, language }}>
            {children}
        </ThemeContext.Provider>
    );
};